import React                from 'react';
import numeral              from 'numeral';
import classnames           from 'classnames';
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome';

import BomRow               from './BomRow'
import PoweredByBomAdmin    from './PoweredByBomAdmin'

const TableHead = (props) => {
  return(
    <thead>
      <tr>
        <th className="fix-column number">Line #</th>
        <th className="fix-column image"></th>
        <th className="fix-column datasheet"></th>
        <th className="fix-column status"></th>
        <th className="fix-column mpn">Manufacturer Part Number</th>
        {props.quantities.map((quantity) => (
          <React.Fragment key={"bom-quantity-" + quantity}>
            <th className={`change-column vendor ${(quantity == props.selected_quantity) ? "activate" : ""}`} 
             data-num-board={quantity}>
              Vendor
            </th>
            <th className={`change-column stock ${(quantity == props.selected_quantity) ? "activate" : ""}`} 
             data-num-board={quantity}>
              Stock
            </th>
            <th className={`change-column required-qty ${(quantity == props.selected_quantity) ? "activate" : ""}`} 
             data-num-board={quantity}>
              Qty <br/>
              Needed
            </th>
            <th className={`change-column price ${(quantity == props.selected_quantity) ? "activate" : ""}`} 
             data-num-board={quantity}>
              Purchase <br/>
              Price
            </th>
          </React.Fragment>
        ))}
        <th className="change-column action">Action</th>
        <th className="change-column mounting-type">Mounting Type</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  var cont = 1;
  var offers = []
  Object.entries(props.offers).forEach(([key, value]) => {
    offers.push(
      <BomRow 
         filter={props.filter} 
         key={"offer-" + key}
         cont={cont++}
         offer_id={key}
         offer={value} 
         quantities={props.quantities} 
         selected_quantity={props.selected_quantity} 
         onChangePartAction = {props.onChangePartAction}
         onChangeMountingType = {props.onChangeMountingType} 
         onViewMore = {props.onFindSubstitutePart} />
    )
  });
  return(
    <tbody>
      {offers}
    </tbody>
  )
}

const TableFooter = (props) => {
  var totals = []
  Object.entries(props.totals).forEach(([key, value]) => {
    totals.push(
      <td colSpan="3" 
       key={"total-" + key}
       className={`total-value ${(key == props.selected_quantity) ? "activate" : ""}`} >
        <div>
          ${numeral(value).format('0.00')}
        </div>
        <div>
          ${numeral(value/parseInt(key)).format('0.00')}
        </div>
      </td>
    )
  });

  return(
    <tfoot>
      <tr>
        <td colSpan="4">
          <PoweredByBomAdmin />
        </td>
        <td colSpan="2" className="total-label">
          <div>TOTAL PARTS COST:</div>
          <div>PARTS COST PER BOARD:</div>
        </td>
        {totals}
        <td colSpan="2"></td>
      </tr>
    </tfoot>    
  )
}

const BomQuoteTable = (props) => {
  return(
    <div className="bom-quote-table">
      <table className="table fixed_header table-responsive">
        <TableHead 
          quantities={props.quantities} 
          selected_quantity={props.selected_quantity} />
        <TableBody 
          filter={props.filter} 
          offers={props.offers} 
          quantities={props.quantities} 
          selected_quantity={props.selected_quantity} 
          onChangePartAction = {props.onChangePartAction}
          onChangeMountingType = {props.onChangeMountingType} 
          onFindSubstitutePart = {props.onFindSubstitutePart} />
        <TableFooter 
          quantities={props.quantities} 
          totals={props.totals} 
          selected_quantity={props.selected_quantity} />
      </table>
    </div>
  )
}
export default BomQuoteTable;
